import { Icon } from '@assembly-js/design-system';
import { SvgIconProps } from '@mui/material';

export const SignatureInitialIcon = ({ className, style }: SvgIconProps) => (
  <Icon
    icon="pencil"
    className={className}
    // The pencil glyph's artwork runs edge-to-edge in its viewBox, unlike its
    // sibling sidebar icons which have built-in padding, so it reads larger
    // at the same box size — sized down to match their apparent weight.
    style={{ width: '0.85em', height: '0.85em', ...style }}
  />
);
